export enum BinderTypes {
  Project = 'Project',
  Facility = 'Facility',
  Procurement = 'Procurement',
  Organization = 'Organization',
  Assignment = 'Assignment',
  Selection = 'Selection',
  UnsupportedBinderType = 'UnsupportedBinderType'
}
